<template>
    <!-- 微信提示层，默认隐藏 -->
    <div v-if="showWeixinTip" class="weixin-tip">
        <p>请点击右上角↗<br>选择系统浏览器打开</p>
    </div>
    <div>
        <section class="intro-section"> 
            <div class="image-wrapper">
                <div class="text-container"> 
                    <h1 class="header-title" v-html="$t('realFeelAI')"></h1>
                    <p class="intro-description">{{ $t('description') }}</p>
                    <img src="@/assets/images/Frame_6263.png" alt="Item 1" class="log-show" />
                    <div class="button-container">
                        <!-- Android 按钮改为点击触发，复用 handleDownload 逻辑 -->
                        <button class="custom-button" @click="handleDownload('android')">
                            <img src="@/assets/images/android_download.png" alt="Item 1" class="download-icon" />
                            <span class="download-title">Android</span>
                        </button>
                        <!-- iOS 按钮复用 handleDownload 逻辑，删除单独判断 -->
                        <button class="custom-button" @click="handleDownload('ios')">
                            <img src="@/assets/images/download-ios.png" alt="Item 1" class="download-icon" />
                            <span class="download-title">iOS</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { isAndroid, isIOS, isWeixinBrowser } from '@/utils/deviceDetector';

export default {
    components: {},
    name: 'HomePage',
    setup() {
        const showWeixinTip = ref(false);
        const fileSize = ref(0);
        const config = {
            androidApkUrl: '/apk/aikes_v4.0.2.apk',
            iosAppStoreCN: 'https://apps.apple.com/cn/app/aikes/id6714469960',
            iosAppStoreGlobal: 'https://apps.apple.com/us/app/aikes/id6714469960',
            googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.xinteract',
        };
        // 解析URL中的region参数（新增小写转换，避免大小写问题）
        const route = useRoute();
        const region = (route.query.region || 'cn').toLowerCase();

        // Android 下载逻辑
        const downloadAndroid = () => {
            const link = document.createElement('a');
            link.href = config.androidApkUrl;
            link.download = 'aikes_v4.0.2.apk';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        // 核心下载逻辑（包含微信提示）
        const handleDownload = (platform) => {
            // 微信环境：显示提示层，终止后续操作
            if (isWeixinBrowser()) {
                showWeixinTip.value = true;
                console.log('微信环境，显示提示层'); // 用于调试
                return;
            }

            // 非微信环境：按平台+地域跳转
            if (platform === 'android') {
                region === 'global' 
                    ? window.location.href = config.googlePlayUrl 
                    : downloadAndroid();
            } else if (platform === 'ios') {
                window.location.href = region === 'global' 
                    ? config.iosAppStoreGlobal 
                    : config.iosAppStoreCN;
            }
        };

        // 页面挂载时自动处理（无需判断微信，直接传入平台）
        onMounted(async () => {
            // 获取 APK 文件大小（非核心逻辑）
            try {
                const res = await fetch(config.androidApkUrl, { method: 'HEAD' });
                const size = parseInt(res.headers.get('content-length'), 10) || 0;
                fileSize.value = (size / (1024 * 1024)).toFixed(2);
            } catch (err) {
                console.error('获取文件大小失败:', err);
            }

            // 自动触发对应平台下载（微信环境会在 handleDownload 中显示提示）
            if (isAndroid()) {
                handleDownload('android');
            } else if (isIOS()) {
                handleDownload('ios');
            }
        });

        return {
            showWeixinTip,
            fileSize,
            handleDownload // 暴露给模板调用
        };
    }
};
</script>

<style scoped>
@import '@/assets/styles/homepage.css';
.weixin-tip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    z-index: 9999;
}

.weixin-tip p {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
}
</style>